import { render, staticRenderFns } from "./PerfilesView.vue?vue&type=template&id=d9ae96d4"
import script from "./PerfilesView.vue?vue&type=script&lang=js"
export * from "./PerfilesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports